export default __webpack_public_path__ + "static/ibm-plex-serif-v10-latin-regular-ba3cdd439d67302238f94f9dff582df0.woff2";